import MuiTab from "@mui/material/Tab";
import MuiTabs from "@mui/material/Tabs";
import { styled } from "@mui/material/styles";
import * as React from "react";

const Tabs = styled(MuiTabs)({
    "& .MuiTabs-flexContainer": {
        alignItems: "flex-start",
    },
    "& .MuiTabs-indicator": {
        display: "none",
    },
});

const Tab = styled(MuiTab)(({ theme }) => ({
    width: "100%",
    alignItems: "flex-start",
    textTransform: "none",
    ":not(:last-child)": {
        borderBottom: `1px solid ${theme.palette.grey["500"]}`,
    },
})) as typeof MuiTab;

function a11yProps(index: number) {
    return {
        id: `vertical-tab-${index}`,
        "aria-controls": `vertical-tabpanel-${index}`,
    };
}

export type ProductNavigationItem = {
    id: string;
    label: string;
    isAvailable: boolean;
};

type ProductPageNavigationProps = {
    items: ProductNavigationItem[];
    activeItemId?: string;
    onChange: (event: React.SyntheticEvent, selectedItemId: string) => void;
};

export function ProductPageNavigation({ items, activeItemId, onChange }: ProductPageNavigationProps) {
    return (
        <Tabs
            orientation="vertical"
            variant="scrollable"
            onChange={onChange}
            aria-label="Product navigation"
            visibleScrollbar={false}
            scrollButtons={false}
            value={activeItemId}
        >
            {items.map((item, index) => (
                <Tab key={index} label={item.label} value={item.id} {...a11yProps(index)} />
            ))}
        </Tabs>
    );
}
